import { useQuery } from "@tanstack/react-query";
import React from "react";

import SevenDaysReminder from "../components/Blocks/SevenDaysReminder";
import ToggleBlock from "../components/Blocks/ToggleBlock";
import { usePatient } from "../context/PatientContext";
import { fetchReminderList } from "../HTTPS/VitalApis";

import MainAreaWrapper from "../layout/MainAreaWrapper";
import {
  convertDate,
  convertLocalDateToUTCDateTime,
} from "../utils/chartUtils";

const Reminder = () => {
  const { patient } = usePatient();

  const { data: reminderList, isLoading } = useQuery({
    queryKey: ["ReminderList", patient?.id],
    queryFn: () =>
      fetchReminderList(
        patient?.id,
        convertLocalDateToUTCDateTime(
          convertDate(new Date(new Date().getTime())),
        ), // yesterday date
        convertLocalDateToUTCDateTime(
          convertDate(new Date(new Date().getTime() + 7 * 24 * 60 * 60 * 1000)),
        ), // seven days after date
      ),
    enabled: !!patient?.id,
  });

  const { data: missedReminderList, isLoadingMissedReminderList } = useQuery({
    queryKey: ["ReminderMissedList", patient?.id],
    queryFn: () =>
      fetchReminderList(
        patient?.id,
        convertLocalDateToUTCDateTime(
          convertDate(new Date(new Date().getTime() - 1 * 24 * 60 * 60 * 1000)),
        ), // yesterday date
        convertLocalDateToUTCDateTime(
          convertDate(new Date(new Date().getTime())),
        ), // seven days after date
      ),
    enabled: !!patient?.id,
  });
  return (
    <MainAreaWrapper>
      <main className="bg-white mt-28 lg:mt-10 rounded-t-3xl">
        <div className="mx-auto  p-4 md:p-6 2xl:p-10">
          <div className="mx-auto px-10">
            {/* <!-- Breadcrumb Start --> */}
            <div className="mb-6 flex flex-row items-center justify-between gap-3">
              <h2 className="text-5xl font-bold text-[#1D3E7D]">Reminders</h2>
            </div>
            {/* <span className="font-bold text-xl">{reminders}</span> */}
          </div>
          <hr />
          <ToggleBlock
            blockOneName="Current"
            blockOne={
              <SevenDaysReminder
                reminderList={reminderList}
                isLoading={isLoading}
              />
            }
            blockTwoName="Past"
            blockTwo={
              <SevenDaysReminder
                reminderList={missedReminderList}
                isLoading={isLoadingMissedReminderList}
              />
            }
          />
        </div>
      </main>
    </MainAreaWrapper>
  );
};

export default Reminder;
